import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';

import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const OfferPriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${getPurpurSpacing('200')};
    margin-bottom: ${getPurpurSpacing('250')};
`;

const responsiveColumnGap = css`
    column-gap: ${getPurpurSpacing('50')};

    ${purpurMedia('md')`
        column-gap: ${getPurpurSpacing('100')};
    `}
`;

export const StyledOfferLineWithTooltip = styled.div`
    display: flex;
    align-items: baseline;
    ${responsiveColumnGap}
`;

export const OfferPriceLine = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    ${responsiveColumnGap}
`;

export const OfferPriceLabel = styled.span`
    font-size: ${getPurpurTypography('scale100')};
    color: ${getPurpurColor('functionalBlack')};
`;

export const OfferPriceText = styled.span<{ $size?: 'sm' | 'md' | 'lg' }>`
    font-size: ${({ $size }) =>
        match($size)
            .with('lg', () => getPurpurTypography('scale500'))
            .with('md', () => getPurpurTypography('scale400'))
            .otherwise(() => getPurpurTypography('scale100'))};
    line-height: ${({ $size }) =>
        match($size)
            .with('lg', 'md', () => getPurpurTypography('lineHeightDefault'))
            .otherwise(() => getPurpurTypography('lineHeightLoose'))};

    font-weight: ${getPurpurTypography('weightBold')};
`;

export const CurrencyLabel = styled.span<{ $bold?: boolean }>`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${({ $bold }) => getPurpurTypography($bold === false ? 'weightMedium' : 'weightBold')};
`;

export const PriceBlock = styled.div<{
    $color?: 'accent' | 'black';
}>`
    display: flex;
    align-items: flex-end;
    ${responsiveColumnGap}
    color: ${({ $color }) =>
        match($color)
            .with('accent', () => getPurpurColor('textStatusDiscount'))
            .with('black', () => getPurpurColor('functionalBlack'))
            .otherwise(() => 'inherit')};
`;

export const OldPriceTextAndLabel = styled.div`
    color: ${getPurpurColor('beige700')};
    font-size: ${getPurpurTypography('scale100')};
    text-decoration: line-through;
`;
